<div class="modal-content">
    <div class="modal-header justify-content-center">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
          <i class="nc-icon nc-simple-remove"></i>
      </button>
        <!-- <h5 class="title title-up">{{ title }}</h5> -->
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="card card-plain">
                <div class="card-header" role="tab" id="headingOne">
                    <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Anexe o motivo da reprovação do movimento.
                  </span>
                </div>
                <div class="card-body">
                    <form [formGroup]="form">
                        <div class="row justify-content-center">
                            <div class="col-md-4 mx-auto">
                                <div class="form-group">
                                    <label for="nome">Descrição da Evidencia</label>
                                    <textarea type="text" class="form-control" placeholder="Evidencia"
                                        formControlName="dS_BPM_TEXTO_EVIDENCIA"></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 p-3">
                                <input #file 
                                type="file" 
                                enctype="multipart/form-data" 
                                (change)="onChange(file.files)"
                                value="arquivo.cD_BPM_ARQUIVO_PATRIMONIAL">  
                            </div>
                            <div>
                                
                            </div>
                            <div class="progress mw-100">
                                <div class="progress-bar bg-success" 
                                role="progressbar"  
                                aria-valuenow="25" 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                                [style.width]="progress + '%'">
                                {{  progress  }}
                              </div>
                            </div>

                        </div>
                    </form>
                    <div class="row">
                        <div class="col-md-12 text-center" *ngIf="loading">
                            <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading" class="modal-footer">
        <div class="left-side">
            <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close()">
              Cancelar
          </button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
            <button type="button" class="btn btn-success btn-link"(click)="reprovar()">
              Reprovar
          </button>
        </div>
    </div>
</div>